module.exports = __webpack_public_path__ + "static/drawing-header-0a48ca216204368be4b7f6c7ac302d12.png";